import { render, staticRenderFns } from "./episodesCarousel.vue?vue&type=template&id=56274634&scoped=true&"
import script from "./episodesCarousel.vue?vue&type=script&lang=js&"
export * from "./episodesCarousel.vue?vue&type=script&lang=js&"
import style0 from "./episodesCarousel.vue?vue&type=style&index=0&id=56274634&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56274634",
  null
  
)

export default component.exports